// src/api/employeeApi.js
import api from '../axiosConfig';

const API_URL = '/api/employees'; 

export const fetchEmployees = () => api.get(API_URL);
export const createEmployee = (data) => api.post(API_URL, data);
export const updateEmployee = (id, data) => api.put(`${API_URL}/${id}`, data);
export const deleteEmployee = (id) => api.delete(`${API_URL}/${id}`);
